import Vue from 'vue'
import request from 'axios'
import state from 'lib/appState'
import validate from 'mixins/validate'
import Cart from 'lib/cart'

Vue.component('cart-promo-code', {
  props: [
    'type',
    'minPrice'
  ],
  mixins: [validate],
  data () {
    return {
      state,
      freeGiftVariantId: '',
      listDiscountCode: '',
      promoCode: '',
      isValid: false,
      showCouponMesage: false
    }
  },
  mounted () {
    const listDiscountCode = this.$el.getAttribute('data-list')
    this.freeGiftVariantId = this.$el.getAttribute('data-product')
    this.listDiscountCode = listDiscountCode ? listDiscountCode.split(', ') : ''
    this.state.freeGiftVariantId = Number(this.freeGiftVariantId)
    this.state.freeGiftType = this.type
    this.state.freeGiftGoal = this.minPrice
  },
  methods: {
    promoCodeSubmit (e) {
      const cartTotalPrice = this.state.cart.total_price
      if (this.promoCode.length > 0) {
        // Add Free gift product to mini cart
        if (this.freeGiftVariantId && this.listDiscountCode.includes(this.promoCode) && this.type === 'code' && cartTotalPrice >= this.minPrice) {
          try {
            const freeGiftVariantId = Number(this.freeGiftVariantId)
            const cartItems = state.cart.items
            const result = cartItems.filter(product => {
              return product.id === freeGiftVariantId
            })

            if (result.length < 1) {
              let payload = [{
                id: freeGiftVariantId,
                quantity: 1
              }]
              Cart.add(payload)
            }
          } catch (error) {
            console.log(error)
          }
        }

        this.showCouponMesage = false
        try {
          const {data} = request.get('/checkout', {
            params: {
              discount: this.promoCode
            }
          })
          const results = String(data)
          const isDiscount = results.indexOf('error-for-reduction_code')

          if (isDiscount > 1) {
            this.isValid = true
          } else {
            this.isValid = false
            this.showCouponMesage = true
            request.get('/discount/' + this.promoCode)
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.isValid = true
      }
    },
    onInputChange ({name, value}) {
      this.promoCode = value
    },
    isValidPrmoCode ({ value }) {
      if (this.promoCode && !this.promoCode.length) {
        return false
      }
      return true
    }
  }
})
